import StampApi from '@apis/stamp/StampApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetStampHistoriesParams, StampCardSorter } from '@models/stamp';

const stampQueries = createQueryKeys('stamps', {
  cardList: (sorter: StampCardSorter) => ({
    queryKey: ['stampCards', sorter],
    queryFn: () => StampApi.getStampCards(sorter),
  }),
  history: (shopId: string, params: GetStampHistoriesParams) => ({
    queryKey: ['histories', shopId, params],
    queryFn: () => StampApi.getStampHistories(shopId, params),
  }),
});

export default stampQueries;
